import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const CompactQuoteButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/quote");
  };

  return (
    <Button 
      size="default"
      onClick={handleClick}
      className="bg-[#8B5CF6] hover:bg-[#7C3AED] text-white px-8 py-2 h-auto text-sm font-medium rounded-md transition-colors w-[200px]"
    >
      Get Quote
    </Button>
  );
};

export default CompactQuoteButton;